module.exports = __webpack_public_path__ + "img/plus.c828f1a3.svg";